var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"main-wrapper"},[_vm._t("header"),_vm._t("body"),_vm._t("system")],2)}
var staticRenderFns = []

export { render, staticRenderFns }